import { GameVisuals } from "../../../gql/graphql";
import { Cell } from "./Cell";
import { Row } from "./Row";

type CurrentRowProps = {
  currentGuess: string;
  solution: string;
  theme: GameVisuals;
};

export const CurrentRow = ({ currentGuess, solution, theme }: CurrentRowProps) => {
  const splitGuess = currentGuess.split("");
  const emptyCells = Array.from(Array(solution.length - splitGuess.length));

  return (
    <Row>
      {splitGuess.map((letter, i) => (
        <Cell key={i} letter={letter} theme={theme} />
      ))}
      {emptyCells.map((_, i) => (
        <Cell key={i} theme={theme} />
      ))}
    </Row>
  );
};
